// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".correct-images-match-picker[data-v-79cd6712]{display:flex;flex-direction:column;align-items:flex-end;width:100%;position:relative}.correct-match[data-v-79cd6712]{width:50%;font-weight:700;font-size:1rem;color:#0f2345;margin-bottom:10px}.actions[data-v-79cd6712]{display:none;justify-content:center;align-items:center;margin-top:10px;width:100%}", ""]);
// Exports
module.exports = exports;
